import { render, staticRenderFns } from "./AplicacaoRegrasAcesso.vue?vue&type=template&id=6fe58a92&"
import script from "./AplicacaoRegrasAcesso.vue?vue&type=script&lang=js&"
export * from "./AplicacaoRegrasAcesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports